import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";

function ConceptosFacturacion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus, setModalContainerStatus] = useState('');
    const [modalBackdropStatus, setModalBackdropStatus] = useState('zindex-back');
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [toastMsg, setToastMsg] = useState('');

    const [showModalForm, setShowModalForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        id: null,
        nombre: ''
    });

    let userdata = [];

    const cols = [
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '75%' },
        { name: 'Acción', cell: row => getBotones(row), width: '25%' }
    ];

    const getBotones = (item) => {
        return (
            <>
                <button onClick={() => handleEditar(item)} className="btn btn-primary btn-sm mr-1">
                    <i className="far fa-edit"></i> Editar
                </button>
                <button onClick={() => showModal(item.id)} className="btn btn-outline-danger btn-sm">
                    <i className="fas fa-trash-alt"></i> Eliminar
                </button>
            </>
        );
    };

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = () => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/conceptos-facturacion?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setItems(response.data);
                }
            })
            .catch(error => {
                console.log(JSON.stringify(error));
            });
    };

    const handleNuevo = () => {
        setEditMode(false);
        setFormData({
            id: null,
            nombre: ''
        });
        setShowModalForm(true);
    };

    const handleEditar = (item) => {
        setEditMode(true);
        setFormData({
            id: item.id,
            nombre: item.nombre
        });
        setShowModalForm(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        try {
            if (editMode) {
                await axios.put(`/concepto-facturacion/${formData.id}?uid=${userdata.user_id}`, formData);
                setToastMsg('Concepto de Facturación Actualizado Exitosamente');
            } else {
                await axios.post(`/concepto-facturacion?uid=${userdata.user_id}`, formData);
                setToastMsg('Concepto de Facturación Creado Exitosamente');
            }
            setShowModalForm(false);
            cargarDatos();
        } catch (error) {
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    const eliminar = (e) => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        axios.delete(`/concepto-facturacion/${e}?uid=${userdata.user_id}`)
            .then(response => {
                if (response.status === 200) {
                    setToastMsg('Concepto de Facturación Eliminado Exitosamente');
                    cargarDatos();
                    cerrar();
                }
            })
            .catch(error => {
                console.log(error);
                alert('Error al eliminar');
            });
    };

    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    };

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
    };

    const getItemsFiltrados = () => {
        if (!terminoBusqueda) return items;

        return items.filter(item => {
            const busqueda = terminoBusqueda.toLowerCase();
            return (item.nombre || '').toLowerCase().includes(busqueda);
        });
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                        <li className="breadcrumb-item active">Conceptos de Facturación</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Conceptos de Facturación</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <button className="btn btn-primary" onClick={handleNuevo}>
                                        <i className="fas fa-plus"></i> Nuevo Concepto
                                    </button>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar por nombre..."
                                                value={terminoBusqueda}
                                                onChange={(e) => setTerminoBusqueda(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <DataTable
                                        columns={cols}
                                        data={getItemsFiltrados()}
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página:',
                                            rangeSeparatorText: 'de',
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos'
                                        }}
                                        noDataComponent="No hay conceptos de facturación registrados"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {showModalForm && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header bg-dark text-white">
                                    <h4 className="modal-title text-white">
                                        {editMode ? 'Editar Concepto de Facturación' : 'Nuevo Concepto de Facturación'}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalForm(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label>Nombre *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.nombre}
                                                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                                                required
                                                maxLength={255}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalForm(false)}>
                                            Cancelar
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            <i className="fas fa-save"></i> Guardar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                <div className={'modal fade ' + modalContainerStatus} tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-dark text-white">
                                <h5 className="modal-title text-white">Eliminar Concepto de Facturación</h5>
                                <button type="button" className="close text-white" onClick={cerrar}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>¿Está seguro que desea eliminar este concepto de facturación?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={cerrar}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade ' + modalBackdropStatus}></div>

                <Footer showToast={toastMsg !== ''} delay={3000} toastMsg={toastMsg} />
            </div>
        );
    }

    return <Loading />;
}

export default ConceptosFacturacion;
